export const dropStatusDocumento = [
  { value: 'CANCELADO', label: 'CANCELADO' },
  { value: 'CONCLUIDO', label: 'CONCLUÍDO' },
  { value: 'PENDENTE', label: 'PENDENTE' },
];

export const dropStatusGarantia = [
  { value: 'AGUARDANDO REMESSA', label: 'AGUARDANDO REMESSA' },
  {
    value: 'AGUARDANDO REMESSA DA AUTORIZADA',
    label: 'AGUARDANDO REMESSA DA AUTORIZADA',
  },
  { value: 'AGUARDANDO RETORNO', label: 'AGUARDANDO RETORNO' },
  { value: 'ANALISE', label: 'ANÁLISE' },
  { value: 'APROVADO', label: 'APROVADO' },
  { value: 'AUTORIZAR PAGAMENTO', label: 'AUTORIZAR PAGAMENTO' },
  { value: 'ENVIO DO MATERIAL', label: 'ENVIO DO MATERIAL' },
  { value: 'FINALIZAR', label: 'FINALIZAR' },
  { value: 'REPROVADO', label: 'REPROVADO' },
];
